import Icon from '@/components/ui/AppIcon';

interface Feature {
  id: string;
  title: string;
  description: string;
  iconName: 'SparklesIcon' | 'ShieldCheckIcon' | 'ClockIcon' | 'UserGroupIcon';
}

const features: Feature[] = [
  {
    id: 'feature_eco',
    title: 'Eco-Friendly Products',
    description: 'We use only EPA-certified, non-toxic cleaning products that are safe for your family, pets, and the environment.',
    iconName: 'SparklesIcon',
  },
  {
    id: 'feature_guarantee',
    title: 'Satisfaction Guarantee',
    description: 'Not happy with our service? We\'ll come back within 24 hours to make it right, or your money back. No questions asked.',
    iconName: 'ShieldCheckIcon',
  },
  {
    id: 'feature_flexible',
    title: 'Flexible Scheduling',
    description: 'Book same-day, weekly, bi-weekly, or monthly cleanings. Change or cancel up to 24 hours before your appointment.',
    iconName: 'ClockIcon',
  },
  {
    id: 'feature_consistent',
    title: 'Same Team Every Visit',
    description: 'Build trust with familiar faces. We assign the same cleaning professionals to your home for consistency and peace of mind.',
    iconName: 'UserGroupIcon',
  },
];

export default function WhyChooseSection() {
  return (
    <section id="why-choose" className="w-full bg-background py-24 lg:py-32 border-t border-border">
      <div className="container mx-auto px-6 lg:px-12">
        
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-4">
            Why Choose Gelle Cleaning
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We're not just another cleaning service. We're your trusted partner in maintaining a healthy, beautiful home.
          </p>
        </div>
        
        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={feature.id}
              className={`bg-card border border-border rounded-xl p-8 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group reveal delay-${(index + 1) * 100}`}
            >
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <Icon name={feature.iconName} size={32} variant="solid" className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Bottom CTA */}
        <div className="text-center mt-16 reveal delay-500">
          <div className="inline-flex flex-col items-center gap-4 bg-secondary/30 border border-border rounded-xl p-8">
            <Icon name="HeartIcon" size={40} variant="solid" className="text-primary" />
            <p className="text-lg text-foreground font-medium max-w-md">
              Join 1,200+ satisfied customers who trust Gelle Cleaning with their homes
            </p>
            <a 
              href="#booking"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-all active:scale-95 active:shadow-sm"
            >
              Book Your First Cleaning
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </a>
          </div>
        </div>
        
      </div>
    </section>
  );
}